/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module select-all
 */

export { default as SelectAll } from './selectall';
export { default as SelectAllEditing } from './selectallediting';
export { default as SelectAllUI } from './selectallui';
